<div class="content-container status-screen">
  <div class="card">
    <div class="card-header">Масова смяна на статус</div>
    <div class="card-block">
      <form clrForm [formGroup]="filterForm">
        <clr-input-container>
          <label>Номер на ПН</label>
          <input clrInput formControlName="DocumentNo" autocomplete="off" />
          <clr-control-error *clrIfError="'required'">Грешка</clr-control-error>
        </clr-input-container>
      </form>
    </div>
    <div class="card-footer">
      <button class="btn btn-primary" type="submit" (click)="search()">Зареди</button>
      <button class="btn" type="button" (click)="resetSearch()">Изчисти</button>
      <!-- <button class="btn btn-outline" type="button" (click)="findPoWithChildren()">
        Debug: Намери ПН с деца (от 0000001900 надолу)
      </button> -->
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">
    <div class="alert-items">
      <div class="alert-item static">
        <span class="alert-text">{{ error }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="poList.length > 0" class="card">
    <div class="card-block">
      <h4>Има повече от едно ПН с този номер. Моля изберете:</h4>
      <ul class="list compact">
        <li *ngFor="let po of poList" (click)="selectPoFromMultiple(po)">
          {{ po.DocumentType?.TypeName?.BG }} {{ po.DocumentNo }} - {{ po.DocumentDate | date }}
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="loading" class="spinner spinner-md">Зареждане...</div>

  <div *ngIf="tree" class="card">
    <div class="card-header">Документен модел</div>
    <div class="card-block">
      <div class="status-row status-header">
        <div class="status-doc-info">Документ</div>
        <div class="status-select">Нов системен статус</div>
        <div class="status-select">Нов потребителски статус</div>
      </div>
      <clr-tree>
        <clr-tree-node
          *clrRecursiveFor="let branch of treeForView; getChildren: getChildrens"
          [clrExpanded]="true"
        >
          <div
            class="status-node"
            [class.status-invalid]="branch.document._invalid"
            [class.status-skipped]="branch.document._skippedLowerOrder"
            [class.status-readonly]="branch.document._statusChangeAllowed === false"
          >
            <div class="status-row">
              <div class="status-doc-info">
                <div class="status-title">
                  <strong>{{ branch.document.DocumentType?.TypeName?.BG }}</strong>
                  {{ branch.document.DocumentNo }}
                </div>
                <div class="status-subtitle">
                  Текущ статус: {{ changeStatusService.getSystemStatusName(branch.document.State) }}
                  / {{ branch.document.UserStatus?.UserStatusName?.BG || '-' }}
                </div>
              </div>
              <ng-container *ngIf="branch.document._statusChangeAllowed === false; else statusControls">
                <div class="status-select status-readonly-text"></div>
                <div class="status-select"></div>
              </ng-container>
              <ng-template #statusControls>
                <div class="status-select">
                  <select
                    class="clr-select"
                    [(ngModel)]="branch.document._pendingState"
                    (ngModelChange)="onSystemStatusChange(branch)"
                  >
                    <option [ngValue]="null">-</option>
                    <option *ngFor="let s of changeStatusService.getSystemStatusOptions(branch)" [ngValue]="s.state">{{ s.name }}</option>
                  </select>
                </div>
                <div class="status-select">
                  <select
                    class="clr-select"
                    [(ngModel)]="branch.document._pendingUserStatusName"
                    (ngModelChange)="onUserStatusChange(branch)"
                    [disabled]="!branch.document._pendingState"
                  >
                    <option [ngValue]="null">-</option>
                    <option *ngFor="let u of getUserStatusOptions(branch)" [ngValue]="u.UserStatusName.BG">
                      {{ u.UserStatusName.BG }}
                    </option>
                  </select>
                </div>
              </ng-template>
            </div>
            <div *ngIf="branch.document._invalid" class="status-message status-invalid-text">
              {{ branch.document._invalidReason }}
            </div>
            <div *ngIf="branch.document._skippedLowerOrder" class="status-message status-skipped-text">
              Пропуснат - текущият потребителски статус е с по-висок ред, не се сваля
            </div>
          </div>
        </clr-tree-node>
      </clr-tree>
    </div>
    <div class="card-footer">
      <button class="btn btn-primary" [disabled]="!canProcess || disableProcessButton" (click)="processChanges()">
        Промени статусите
      </button>
    </div>
    <div class="card-block">
      <log-monitor
        [logStream]="executionLog | async"
        theme="dark"
        title="Лог на обработката"
        [animated]="true"
        [icons]="true"
      ></log-monitor>
    </div>
  </div>
</div>
